import React from "react";

const TabBar = ({ selectedTab, avgScore, handleSelectedTab }) => (
  <div className="detail-tab hide-xs">
    <ul>
      <li onClick={() => handleSelectedTab("menu")}>
        <a
          className={(selectedTab === "menu" && "active") || ""}
          href="javascript:void(0)"
        >
          Menu
        </a>
      </li>
      <li onClick={() => handleSelectedTab("info")}>
        <a
          className={(selectedTab === "info" && "active") || ""}
          href="javascript:void(0)"
        >
          Info
        </a>
      </li>
      {(avgScore && (
        <li onClick={() => handleSelectedTab("reviews")}>
          <a
            className={(selectedTab === "reviews" && "active") || ""}
            href="javascript:void(0)"
          >
            Reviews
          </a>
        </li>
      )) || <noscript />}
    </ul>
  </div>
);

export default TabBar;
